/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Indemnification_Item_3Inputs */

const es_tyc_indemnification_item_3 = /** @type {(inputs: Tyc_Indemnification_Item_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Su uso no autorizado o inadecuado del Servicio.`)
};

const en_tyc_indemnification_item_3 = /** @type {(inputs: Tyc_Indemnification_Item_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your unauthorized or improper use of the Service.`)
};

/**
* | output |
* | --- |
* | "Your unauthorized or improper use of the Service." |
*
* @param {Tyc_Indemnification_Item_3Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_indemnification_item_3 = /** @type {((inputs?: Tyc_Indemnification_Item_3Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Indemnification_Item_3Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_indemnification_item_3(inputs)
	return en_tyc_indemnification_item_3(inputs)
});
export { tyc_indemnification_item_3 as "tyc.indemnification.item_3" }